module.exports = __webpack_public_path__ + "static/media/avatar.a5d47b3c.svg";